import { apiSlice } from "../../apis/ApiSlice";
const apiUrl = process.env.REACT_APP_API_URL;
const ORGANIZATION_URL = `${apiUrl}/api/user`;

export const organizationapiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    organization: builder.mutation({
      query: (organization) => ({
        url: `${ORGANIZATION_URL}/create-organization`,
        method: "POST",
        body: organization,
      }),
    }),
  }),
});

export const { useOrganizationMutation} = organizationapiSlice;
